module.exports = __webpack_public_path__ + "static/media/hockeygras.a9924134.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/hockeygras.svg
// module id = 382
// module chunks = 7